import {Component, OnInit, ViewChild} from '@angular/core';
import {Employee} from '../admin/models/employee.model';
import {WorkAbroadPopUpComponent} from './work-abroad-pop-up/work-abroad-pop-up.component';
import {PersonalService} from '../personal/personal.service';
import {FabMessageService} from '@fabric/components/message';
import {AuthenticationService} from '../core/authentication/authentication.service';
import {MatDialog} from '@angular/material/dialog';
import {FabThemeService} from '@fabric/components/theme';
import {WorkAbroadService} from './work-abroad.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {WorkAbroad} from '../admin/models/workAbroad.model';
import {ExcelUtil} from '../common/web-workers/excel-export.worker';
import {writeFile} from 'xlsx';
import {CancelPopUpComponent} from '../cancel-pop-up/cancel-pop-up.component';
import {MatSort} from '@angular/material/sort';

@Component({
    selector: 'app-work-abroad',
    templateUrl: './work-abroad.component.html',
    styleUrls: ['./work-abroad.component.scss']
})
export class WorkAbroadComponent implements OnInit {

    @ViewChild(MatPaginator, {static: false})
    set paginator(value: MatPaginator) {
        if (this.dataSource) {
            this.dataSource.paginator = value;
            this.dataSourceAll.paginator = value;
        }
    };

    @ViewChild('workAbroadTable', {read: MatSort, static: false})
    set sortWorkAbroadTable(value: MatSort) {
        if (this.dataSource) {
            this.dataSource.sort = value;
        }
    };

    @ViewChild('workAbroadTableAll', {read: MatSort, static: false})
    set sortWorkAbroadTableAll(value: MatSort) {
        if (this.dataSourceAll) {
            this.dataSourceAll.sort = value;
        }
    };

    public dataSource: MatTableDataSource<WorkAbroad> = new MatTableDataSource<WorkAbroad>([]);
    public dataSourceAll: MatTableDataSource<WorkAbroad> = new MatTableDataSource<WorkAbroad>([]);
    public isPageLoading = false;
    public isRefresh = false;
    public isExcelExporting = false;
    public workAbroad = {} as WorkAbroad;
    public gminValue: string = '';
    public employee = {} as Employee;
    public modifyEmployee = {} as Employee;
    public fieldNames = ['country', 'startDate', 'endDate', 'dateCreated', 'annualLeaveTotal', 'numberOfWorkAbroadDays', 'requestStatus', 'modify', 'cancel'];
    public displayNames = ['Country', 'Start Date', 'End Date', 'Date Created', 'Annual Leave Total', 'Work Abroad Total', 'Request Status', 'Edit', 'Cancel'];
    public years: any[] = [];
    public totalWorkAbroadAllowance: number = 0;
    public remainingWorkAbroadAllowance: number = 0;
    public remainingVacationAllowance: number = 0;
    public pendingWorkAbroadRequests: number = 0;
    public placeholderYear: any;
    public yearHolder: number = 0;
    public pendingWorkAbroadDays: number = 0;
    public isValid = true;
    public displayRollingPeriod: any = '';
    public displayNextTripAllowed: any = '';
    public isChecked = false;
    public isDate = true;

    constructor(private workAbroadService: WorkAbroadService,
                private personalService: PersonalService,
                private messageService: FabMessageService,
                private authService: AuthenticationService,
                private dialog: MatDialog,
                public readonly themeService: FabThemeService) {
    }

    ngOnInit(): void {
        this.gminValue = this.authService.userInfo.gmin || '';
        this.personalService.fetchEmployeeByGmin(this.gminValue).subscribe({
            next: (data) => {
                this.employee = data;
                this.modifyEmployee = data;
                if (this.employee.employeeWorkAbroadAllowance.length === 0) {
                    this.totalWorkAbroadAllowance = 40;
                    this.remainingWorkAbroadAllowance = 40;
                }
                this.getRollingPeriod();
                this.sortYear();
                this.setPlaceHolderYear();
                this.displayDataOnTable(this.placeholderYear);
                this.isPageLoading = false;
                this.isRefresh = false;
                this.isValid = true;
            },
            error: () => {
                this.messageService.displayErrorMessage('Invalid GMIN');
                this.isPageLoading = false;
                this.isValid = false;
            }
        });
        this.isPageLoading = true;
    }


    public getRollingPeriod() {
        let currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        if (this.employee.employeeWorkAbroadAllowance.length === 0) {
            this.displayRollingPeriod = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear() + 1)));
            this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear())));
        } else if (this.employee.employeeWorkAbroadAllowance.length > 0) {
            this.employee.employeeWorkAbroadAllowance.forEach((i) => {
                let rollingStart = new Date(i.rollingPeriodStart);
                let rollingEnd = new Date(i.rollingPeriodEnd);
                if (rollingStart >= currentDate && currentDate <= rollingEnd) {
                    this.displayRollingPeriod = this.personalService.convertDateFormatForAPI(String(i.rollingPeriodEnd));
                    let lengthOfWorkAbroad = this.employee.workAbroad.length;
                    this.employee.workAbroad.forEach((j) => {
                        if (lengthOfWorkAbroad <= 1 && (j.requestStatus == 'CANCELLED' || j.requestStatus == 'DECLINED')) {
                            this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear())));
                        } else if (j.requestStatus !== 'CANCELLED' && j.requestStatus !== 'DECLINED') {
                            if (j.requestStatus == 'APPROVED') {
                                this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(i.nextTripAllowedFrom));
                            } else if (j.requestStatus == 'PENDING') {
                                this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear())));
                            } else {
                                this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(i.nextTripAllowedFrom));
                            }
                        } else {
                            this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear())));
                        }
                    });
                } else {
                    this.displayRollingPeriod = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear() + 1)));
                    this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(new Date().setUTCFullYear(new Date().getUTCFullYear())));
                    this.totalWorkAbroadAllowance = 40;
                    this.remainingWorkAbroadAllowance = 40;
                }
            });
        }
    }


    sortWorkAbroadStartDate() {
        for (const element of this.dataSource.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }

        for (const element of this.dataSourceAll.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     * Set the place holder value for year based on the rolling period start.
     * Will set the default to be for the current year starting rolling period date
     */
    setPlaceHolderYear() {
        let currentRollingPeriod = new Date().getFullYear();
        if (this.employee.employeeWorkAbroadAllowance.length !== 0) {
            this.employee.employeeWorkAbroadAllowance.forEach((i) => {
                for (const element of this.years) {
                    if (element.includes(currentRollingPeriod)) {
                        this.placeholderYear = element;
                    }
                }
            });
        } else {
            this.placeholderYear = `${this.displayNextTripAllowed} - ${this.displayRollingPeriod}`
        }
    }

    /**
     * Loops through the employee's work abroad requests and adds those created in the passed in year to the datasource
     * @param year The year to filter for
     */
    public displayDataOnTable(year: any): void {
        let start = '';
        let end = '';
        this.yearHolder = year;
        if (typeof year === 'string') {
            start = year.substring(0, 10);
            end = year.substring(13, 23)
            year = year.substring(6, 10);
        }
        this.dataSourceAll.data = [];
        const tempDataSource: MatTableDataSource<WorkAbroad> = new MatTableDataSource<WorkAbroad>([]);
        this.employee.workAbroad.forEach((value) => {
                value.annualLeaveTotal = this.calculateAnnualLeaveTotal(value);
            this.dataSourceAll.data.push(value);
            let tempDate;
            if (!value.endDate.includes('/')) {
                tempDate = this.formatDate(value.endDate);
                const dateFrom = start;
                const dateTo = end;
                const dateCheck = tempDate;

                const d1 = dateFrom.split('/');
                const d2 = dateTo.split('/');
                const c = dateCheck.split('/');

                const from = new Date(Number(d1[2]), parseInt(d1[1]) - 1, Number(d1[0]));
                const to = new Date(Number(d2[2]), parseInt(d2[1]) - 1, Number(d2[0]));
                const check = new Date(Number(c[2]), parseInt(c[1]) - 1, Number(c[0]));
                if (check > from && check <= to) {
                    tempDataSource.data.push(value);
                }
            } else {
                tempDate = value.endDate;

                const dateFrom = start;
                const dateTo = end;
                const dateCheck = tempDate;

                const d1 = dateFrom.split('/');
                const d2 = dateTo.split('/');
                const c = dateCheck.split('/');

                const from = new Date(Number(d1[2]), parseInt(d1[1]) - 1, Number(d1[0]));
                const to = new Date(Number(d2[2]), parseInt(d2[1]) - 1, Number(d2[0]));
                const check = new Date(Number(c[2]), parseInt(c[1]) - 1, Number(c[0]));
                if (check > from && check <= to) {
                    tempDataSource.data.push(value);
                }
            }
        });
        if (tempDataSource.data !== null) {
            this.dataSource.data = tempDataSource.data;
        } else {
            this.dataSource.data = [];
        }
        this.employeeLeaveDetails(year);
        this.sortWorkAbroadStartDate();
    }

    /**
     * Update the mat cards when switching between current rolling period and all requests
     * Only updates pending requests and pending days
     */
    public updateMatCards() {
        this.pendingWorkAbroadDays = 0;
        this.pendingWorkAbroadRequests = 0;
        if (!this.isChecked) {
            this.employee.workAbroad.forEach((i) => {
                if (i.requestStatus === 'PENDING') {
                    this.pendingWorkAbroadRequests++;
                    this.pendingWorkAbroadDays += i.numberOfWorkAbroadDays;
                }
            })
        } else {
            this.displayDataOnTable(this.yearHolder);
        }
    }

    formatDate(dateString: string | number | Date) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    /**
     * Loops through employee allowances and assigns values from the current year to variables
     * @param year The year to find values for
     */
    public employeeLeaveDetails(year: number) {
        this.employee.employeeVacationAllowance.forEach((i) => {
            if (i.year == year) {
                this.remainingVacationAllowance = i.vacationAllowanceRemaining;
                this.pendingWorkAbroadRequests = this.workAbroadService.pendingWorkAbroadRequests(this.employee, year);
                this.pendingWorkAbroadDays = this.workAbroadService.pendingWorkAbroadDays(this.employee, year);
            }
        });
        this.employee.employeeWorkAbroadAllowance.forEach((i) => {
            if (parseInt(this.personalService.getYearOfDateString(i.rollingPeriodStart)) == year) {
                this.totalWorkAbroadAllowance = i.allowance;
                this.remainingWorkAbroadAllowance = i.allowanceRemaining;
                this.displayNextTripAllowed = this.personalService.convertDateFormatForAPI(String(i.nextTripAllowedFrom));
                this.displayRollingPeriod = this.personalService.convertDateFormatForAPI(String(i.rollingPeriodEnd));
            }
        });
    }

    /**
     * Formats date values for each work abroad request, adds each allowance year to an array and sorts these
     */
    public sortYear(): void {
        this.employee.workAbroad.forEach((i) => {
            i.dateCreated = this.personalService.convertDateFormat(i.dateCreated);
            i.updatedTimestamp = this.personalService.convertDateFormat(i.updatedTimestamp);
            i.createdTimestamp = this.personalService.convertDateFormat(i.createdTimestamp);
            i.approvalDate = this.personalService.convertDateFormat(i.approvalDate);
        });
        this.employee.employeeWorkAbroadAllowance.forEach((i) => {
            let rollingPeriod = this.personalService.convertDateFormatForAPI(String(i.rollingPeriodStart))
                + ' - ' + this.personalService.convertDateFormatForAPI(String(i.rollingPeriodEnd));
            this.years.push(rollingPeriod);
        });
        this.years.sort((a, b) => (a - b));
        this.years = this.personalService.getUniqueValues(this.years);
    }

    /**
     * Calls a service method to calculate the annual leave total used during a work abroad request
     * @param workAbroad The work abroad request to search for vacation days in
     */
    public calculateAnnualLeaveTotal(workAbroad: WorkAbroad): number {
        return this.workAbroadService.calculateAnnualLeaveTotal(workAbroad);
    }

    /**
     * Opens a popup to modify a work abroad request
     * @param modifyEmployee The employee the work abroad request is for (to get gmin, etc)
     * @param workAbroad The work abroad request to modify
     * @param isEditing flag to identify editing
     */
    public openModifyPopup(modifyEmployee: Employee, workAbroad: WorkAbroad, isEditing: boolean): void {
        const numDaysAbroad = workAbroad.numberOfWorkAbroadDays;
        let vacationDays = 0;
        this.isDate = false;
        if (workAbroad.vacations.length > 0) {
            vacationDays = workAbroad.vacations[0].numberOfAnnualLeaveDays;
        }
        this.dialog.open(WorkAbroadPopUpComponent, {
            data: {
                employee: modifyEmployee,
                workAbroad: workAbroad,
                numDaysAbroad: numDaysAbroad,
                vacationDays: vacationDays,
                isEditing: isEditing,
                editVacationDates: 'edit'
            }
        }).afterClosed().subscribe(() => {
            this.refreshTable();
            this.sortWorkAbroadStartDate();
        });
    }

    /**
     * Opens a popup to add a new work abroad request
     * @param employee The employee the work abroad request is for (to get gmin, etc)
     */
    public openWorkAbroadPopup(employee: Employee): void {
        this.dialog.open(WorkAbroadPopUpComponent, {
            data: {
                nextTrip: this.displayNextTripAllowed,
                rollingPeriod: this.displayRollingPeriod,
                employee,
                workAbroad: null
            }
        }).afterClosed().subscribe(() => {
            this.refreshTable();
        });
    }

    public refreshTable() {
        this.isRefresh = true;
        this.personalService.fetchEmployeeByGmin(this.gminValue).subscribe({
            next: (data) => {
                this.employee = data;
                this.sortYear();
                this.displayDataOnTable(this.yearHolder);
                this.isDate = true;
                this.isRefresh = false;
            },
            error: () => this.messageService.displayErrorMessage('Error fetching data')
        });
    }

    /**
     * Opens a popup to cancel a work abroad request
     * @param workAbroadID The work abroad request to be cancelled
     */
    public openCancelPopup(workAbroadID: string): void {
        this.dialog.open(CancelPopUpComponent, {
            data: {
                vacationID: workAbroadID,
                requestType: 'WORKABROAD'
            }
        }).afterClosed().subscribe(() => {
            this.refreshTable();
        });
    }

    /**
     * Opens a popup to cancel a vacation request
     * @param workAbroad The workabroad request to be cancelled
     */
    public openRequestCancelPopup(workAbroad: WorkAbroad): void {
        this.dialog.open(CancelPopUpComponent, {
            data: {
                workAbroad: workAbroad,
                requestType: 'WORKABROAD',
                requestStatus: 'REQUEST_CANCEL'
            }
        }).afterClosed().subscribe(() => {
            this.refreshTable();
        });
    }

    /**
     * Checks if the startDate had already occurred, and if so returns false
     * @param startDate The date to be checked
     * @param dateCreated
     */
    public checkIfStartDateBeforeCurrentDate(startDate: string, dateCreated: string): boolean {
        return new Date(startDate) >= new Date(dateCreated);
    }

    /**
     * Exports an excel of the table data
     */
    public exportExcel(): void {
        if (this.dataSource.data.length > 0) {
            this.isExcelExporting = true;
            let updatedWorkAbroadExportData = [];
            for (let workAbroadData of this.dataSource.data) {
                const startDate = new Date(workAbroadData['startDate']);
                const startDateString = startDate.getFullYear() + '-' +
                    ('00' + (startDate.getMonth() + 1)).slice(-2) + '-' +
                    ('00' + startDate.getDate()).slice(-2);
                const endDate = new Date(workAbroadData['endDate']);
                const endDateString = endDate.getFullYear() + '-' +
                    ('00' + (endDate.getMonth() + 1)).slice(-2) + '-' +
                    ('00' + endDate.getDate()).slice(-2);

                updatedWorkAbroadExportData.push({
                    'country': workAbroadData['country'],
                    'startDate': startDateString,
                    'endDate': endDateString,
                    'firstDayBack': workAbroadData['firstDayBack'].split("/")[2] + "-" + workAbroadData['firstDayBack'].split("/")[1] + "-" + workAbroadData['firstDayBack'].split("/")[0],
                    'lastDayWorking': workAbroadData['lastDayWorking'].split("/")[2] + "-" + workAbroadData['lastDayWorking'].split("/")[1] + "-" + workAbroadData['lastDayWorking'].split("/")[0],
                    'numberOfWorkAbroadDays': workAbroadData['numberOfWorkAbroadDays'],
                    'dateCreated': workAbroadData['dateCreated'],
                    'approvalDate': workAbroadData['approvalDate'],
                    'requestStatus': workAbroadData['requestStatus'],
                });
            }
            ExcelUtil.exportObjectArrayMultiThreaded(updatedWorkAbroadExportData, 'Work Abroad Days')
                .subscribe({
                    next: (workbook) => {
                        if (workbook) {
                            writeFile(workbook, 'WorkAbroadDays.xlsx');
                            this.isExcelExporting = false;
                        }
                    },
                    error: () => {
                        this.messageService.displayErrorMessage('Failed to export Excel file');
                        this.isExcelExporting = false;
                    }
                });
        } else {
            this.messageService.displayErrorMessage('No data to export');
        }
    }

}
